import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { OperatorService, ClientQuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ModalSuccessImage } from 'assets/img';

interface Props {
	onClose?: any;
}

class ModalSuccess extends React.Component<Props> {

	render() {
		return (
			<div id="modal-success-quote">
				<img src={ ModalSuccessImage } />
				<h3>Su pago ha sido exitoso</h3>
				<p>Recibirá un correo electrónico con todos los detalles de su reserva y la información del talento asignado.</p>
				<p>¿Hay algo más en lo que podamos ayudarle?</p>
				<div className="row">
					<div className="col-md-6 text-center">
						<button className="btn btn-transparent" onClick={ () => this.props.onClose(true) }>
							Si
						</button>
					</div>
					<div className="col-md-6 text-center">
						<button className="btn btn-transparent" onClick={ () => this.props.onClose() }>
							Cerrar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalSuccess;